import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import withRouter from 'HOCs/withRouter';
import css from './SellerCard.APP_TARGET.scss';
import { compose } from 'redux';
import Auth from './../../../Auth';
import SellerBrand, { LOGO_TYPE } from '../components/SellerBrand';
import withTrack from 'HOCs/withTrack/withTrack';
import FollowSection from '../components/FollowSection';
import LocationDetails from '../components/LocationDetails';
import OperatingDetails from '../components/OperatingDetails';
import VerifiedAccounts from 'Components/Profile/VerifiedAccounts/VerifiedAccounts.mobile';
import { isMobile } from 'Helpers/devices';
import CallToActions from '../components/CallToActions';
import ShareProfile from 'Components/Profile/ShareProfile/ShareProfile';
import ReportUser from 'Components/Profile/ReportUser/ReportUser';
import { threadMeetingSelector } from 'Selectors/chat';
import _setLoginModalState from 'Actions/setLoginModalState';
import AdExpiration from '../components/AdExpiration';
import withConfig from 'HOCs/withConfig/withConfig';
import { LIGHT } from 'Constants/buttons';
import { TrackerOrigins } from 'Components/TrackerProvider/TrackerProvider';

export const COCOSeller = ({
    actionButtons,
    address,
    config,
    currentOpenState,
    followers,
    following,
    isMyItem,
    isOpen,
    item,
    operatingDetailsObject,
    onClickProfile,
    latitude,
    locality,
    longitude,
    meta,
    operatingDays,
    operatingTime,
    profileLink,
    sellerProfilePage,
    showFollowSection,
    showLocation,
    showOperatingDetails,
    showReportUser,
    showVerifiedAccounts,
    user,
    userImage,
    userIsLogged,
    userName,
    adpvTxnRevamp,
    loggedUser,
    coverImages,
    isCurrentlyOpen,
    escrowDetails
}) => {
    const userLogged = Auth.getUser();
    const isLocationDetailsAvailable = !!(showLocation && address && latitude && longitude);
    const isOperatingDetailsAvailable = !!(showOperatingDetails && (currentOpenState || sellerProfilePage) && Object.keys(operatingDetailsObject).length);
    const showSellerLinkAdpv = config.get('showSellerLinkAdpv');
    const isClassified = true;

    return (
        <div className={ classNames(css.sellerInfoContainer, { [css.modernSellerInfoContainer]: isClassified }) } data-aut-id="sellerInfo" >
            <SellerBrand
                olxAutosLogo={ LOGO_TYPE.LARGE }
                locality={ locality }
                userName={ userName }
                userImage={ userImage }
                user={ user }
                meta={ meta }
                followers={ followers }
                following={ following }
                profileLink={ isClassified ? profileLink : null }
                sellerProfilePage={ sellerProfilePage }
                isClassified={ isClassified }
                address={ address }
                latitude={ latitude }
                longitude={ longitude }
                showDirectionsCTA={ true }
                currentOpenState={ currentOpenState }
                operatingTime={ operatingTime }
                operatingDays={ operatingDays }
                userIsLogged={ userIsLogged }
                adpvTxnRevamp={ adpvTxnRevamp }
                loggedUser={ loggedUser }
                operatingDetailsObject={ operatingDetailsObject }
                coverImages={ coverImages }
                isCurrentlyOpen={ isCurrentlyOpen }
            />
            {
                !isMyItem && !isMobile && actionButtons
            }
            {
                isMyItem && <AdExpiration
                    status={ item.status }
                    itemValidTo={ item.valid_to }
                    data-aut-id="sellerCardAdExpiration"
                />
            }
            {
                isMyItem
                && <CallToActions item={ item } escrowDetails={ escrowDetails } data-aut-id="sellerCardCallToActions" />
            }
            {!sellerProfilePage && showFollowSection && <FollowSection user={ user } /> }
            {!sellerProfilePage && <div className={ classNames(
                css.sellerDetailsBox,
                { [css.greyBox]: (isLocationDetailsAvailable || isOperatingDetailsAvailable) }
            ) }>
                { isLocationDetailsAvailable && <LocationDetails
                    address={ address }
                    latitude={ latitude }
                    longitude={ longitude }
                    showDirectionsCTA={ true }
                />
                }
                { isOperatingDetailsAvailable && <OperatingDetails
                    currentOpenState={ currentOpenState }
                    operatingDetailsObject={ operatingDetailsObject }
                    isOpen={ isOpen }
                />
                }
                {showSellerLinkAdpv
                    && <ShareProfile
                        isLinkCenter={ isLocationDetailsAvailable || isOperatingDetailsAvailable || !isMobile }
                        isLink={ !sellerProfilePage }
                        profileLink={ profileLink }
                        onClickProfile={ onClickProfile }
                        userId={ user.id }
                        textId={ sellerProfilePage ? 'shareProfile' : 'profileLinkTxt' }
                        origin={ TrackerOrigins.VIEW_ITEM }
                    />
                }
            </div>}

            { !isClassified && showVerifiedAccounts && <VerifiedAccounts user={ user } showTitle={ showVerifiedAccounts } socialIconType={ LIGHT } /> }
            { !isClassified && userLogged && user.id && user.id !== userLogged.id && showReportUser
                && <div className={ css.reportBtn } >
                    <ReportUser userId={ user.id } shiftReportLeft={ showReportUser } />
                </div>
            }

        </div>
    );
};

COCOSeller.propTypes = {
    userImage: PropTypes.string,
    userName: PropTypes.string,
    locality: PropTypes.string,
    address: PropTypes.string,
    currentOpenState: PropTypes.string,
    operatingDetailsObject: PropTypes.object,
    profileLink: PropTypes.string,
    onClickProfile: PropTypes.func,
    latitude: PropTypes.string,
    longitude: PropTypes.string,
    sellerProfilePage: PropTypes.bool,
    user: PropTypes.object,
    showFollowSection: PropTypes.bool,
    showVerifiedAccounts: PropTypes.bool,
    showReportUser: PropTypes.bool,
    showLocation: PropTypes.bool,
    showOperatingDetails: PropTypes.bool,
    meta: PropTypes.func,
    followers: PropTypes.array,
    following: PropTypes.array,
    item: PropTypes.object,
    router: PropTypes.shape({
        push: PropTypes.func.isRequired
    }),
    isMyItem: PropTypes.bool,
    actionButtons: PropTypes.object,
    isOpen: PropTypes.bool,
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }).isRequired,
    userIsLogged: PropTypes.bool,
    adpvTxnRevamp: PropTypes.bool,
    operatingTime: PropTypes.string,
    operatingDays: PropTypes.string,
    loggedUser: PropTypes.object,
    isCurrentlyOpen: PropTypes.bool,
    coverImages: PropTypes.array,
    escrowDetails: PropTypes.object
};

COCOSeller.defaultProps = {
    userImage: '',
    userName: '',
    locality: '',
    address: '',
    currentOpenState: '',
    operatingDetailsObject: {},
    profileLink: '',
    onClickProfile: () => {},
    latitude: '',
    longitude: '',
    sellerProfilePage: false,
    user: {},
    showFollowSection: false,
    showVerifiedAccounts: false,
    showReportUser: false,
    showLocation: true,
    showOperatingDetails: true,
    item: {},
    isMyItem: false,
    actionButtons: null,
    isOpen: false,
    adpvTxnRevamp: false,
    operatingTime: '',
    operatingDays: '',
    loggedUser: {}
};

export const mapStateToProps = (state, { user, item }) => {
    return {
        threadMeeting: threadMeetingSelector(state, { userId: user?.id, itemId: item?.id })
    };
};

const mapDispatchToProps = {
    setLoginModalState: _setLoginModalState
};

export default compose(
    withConfig,
    withTrack,
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(COCOSeller);
